import { render, staticRenderFns } from "./InstanceGame.vue?vue&type=template&id=3babd0da&scoped=true&"
import script from "./InstanceGame.vue?vue&type=script&lang=js&"
export * from "./InstanceGame.vue?vue&type=script&lang=js&"
import style0 from "./InstanceGame.vue?vue&type=style&index=0&id=3babd0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babd0da",
  null
  
)

export default component.exports